module.exports = function(media) {
	media
    .controller('newVideoController', newVideoController)

	newVideoController.$inject = ["API_URL","$interval","$state","$scope","getDataService", 'jQuery', '$stateParams','refreshtokenService','config','authtokenService','postDataService', 'alertService','serverError','$rootScope', 'reqursiveService','checkArray','$http','offlineError'];
	
  function newVideoController(API_URL,$interval,$state,$scope,getDataService,jQuery, $stateParams,refreshtokenService,config, authtokenService,postDataService, alertService,serverError,$rootScope, reqursiveService, checkArray,$http,offlineError) {
    var vmnv = this;
    var state = 'video';
    vmnv.firstBind = false;
    vmnv.data_grid = [];
    vmnv.config = config;
    vmnv.selectedTranscoding={value:vmnv.config.videoUploadVersion}
    Dropzone.autoDiscover = false;
    vmnv.editImageModal = false;
    vmnv.upload_title = ''
    vmnv.upload_signature = '';
    vmnv.upload_description = '';
    vmnv.tags = [];
    vmnv.selectedImage = -1;
    vmnv.uploadedThumb = false;
    vmnv.uploadVideoRequired = false;
    vmnv.thumbRequired = false;
    vmnv.thumbsLoaded = {};
    vmnv.custom_image = '';
    vmnv.image = null;
    vmnv.addSafety =config.addSafety;
    vmnv.safe = null;
    vmnv.checkedItems ={};
    vmnv.videoSafeRequired = false;
    vmnv.geoAllowance = config.geoRestrictions;
    vmnv.allowCheckedItems = {};
    vmnv.selectedVideoQuality = {value:'medium'};
    var geoAllowanceUpdateFunction = function() {
      for(var i=0; i<vmnv.geoAllowance.length;i++) {
        vmnv.allowCheckedItems[vmnv.geoAllowance[i]._id] = false;
      }
    }
    geoAllowanceUpdateFunction();
    vmnv.allowCheckedItems[vmnv.geoAllowance[0]._id] = true;
    vmnv.geoAllow = vmnv.geoAllowance[0]._id;
    vmnv.updateAllowance = function(allowance) {
      if(vmnv.allowCheckedItems[allowance]) {
          putGeoAllowanceFunction(allowance);
      }
      geoAllowanceUpdateFunction();
      vmnv.allowCheckedItems[allowance] = true;
    }
    var putGeoAllowanceFunction = function(allowance) {
      var url = API_URL + 'video/georestrictions/'+ vmnv.videoNew._id; 
        var updateDataPosts = {
          "allowance": allowance,
          "video_id": vmnv.videoNew.video_id,
          "isUpdate": false
        }
        var putFunction = function() {
          $http.put(url , updateDataPosts)
          .success(function (data, status, headers) {
              alertService('success','Success ', data.message, 2000);
              vmnv.geoAllow = allowance;
          })
          .error(function (data, status, header, config) {
            if(!window.navigator.onLine) {
              offlineError()
              geoAllowanceUpdateFunction();
              vmnv.allowCheckedItems[vmnv.geoAllow] = true;
              alertService('danger','Opps! ', 'Please check your internet connection and try again.');
              return
            }
            if(status ==401) {
              var promise = refreshtokenService.getAccessToken();
              promise.then(
                function(answer) {
                  if(answer==200) {   
                    putFunction();
                  }
                },
                function(error) {
                  // report something
                },
                function(progress) {
                  // report progress
              });
            }else if(status ==502) {
              serverError();
            } else {  
              alertService('danger','Opps! ', (data && data.error && data.error.message)? data.error.message:'Failed to load response data.');
            
            }
            geoAllowanceUpdateFunction();
            vmnv.allowCheckedItems[vmnv.geoAllow] = true;
          });
        }
        putFunction();
    }
    vmnv.chooseImage = function(index) {
        // if(vmnv.thumbsLoaded.all) {
            vmnv.selectedImage = index;
            if(vmnv.thumbs.length == vmnv.thumbsLocked.length) {
              vmnv.image = vmnv.thumbsLocked[index] 
            } else {
              if(index==vmnv.thumbs.length-1) {
                vmnv.image = vmnv.customThumbsLocked;
              } else {
                  vmnv.image = vmnv.thumbsLocked[index];
              }
            } 
            jQuery('.upload-image').attr('src', vmnv.thumbs[index])
        // }
    }
    vmnv.uploaded = false;
    vmnv.dzOptions = {
        url : config.videoUploadUrl+'api/'+vmnv.selectedTranscoding.value+'/upload',
        paramName : 'filename',
        maxFilesize : '500000',
        parallelUploads: 10,  
        acceptedFiles : '.mp4',
        addRemoveLinks : true,
        autoProcessQueue : false,
        dictInvalidFileType: 'This file type is not supported.',
        dictFileTooBig:'File size too Big',
        dictDefaultMessage : "Drop video here to upload",
        headers:{
          'x-auth': null  
        },
        
    };
    
    //Handle events for dropzone
    //Visit http://www.dropzonejs.com/#events for more events
    vmnv.dzCallbacks = {
        'processing': function(file) {
          var dz = vmnv.dzMethods.getDropzone();
          dz.options.url=config.videoUploadUrl+'api/'+vmnv.selectedTranscoding.value+'/upload';
        }, 
        'addedfile' : function(file){
            vmnv.newFile = file;
           var getVideoToken = function() {  
              postDataService.save({
                param1: state,
                // param2: 'token'  
                }).$promise.then(function(data){
                vmnv.videoNew = data.video;
                vmnv.dzOptions.headers['x-auth'] = vmnv.videoNew.video_id;
                vmnv.dzMethods.processQueue();
              },function(error){
                if(error.status ==401) {
                  var promise = refreshtokenService.getAccessToken();
                  promise.then(
                    function(answer) {
                      if(answer==200) {   
                        getVideoToken();
                      }

                    },
                    function(error) {
                      // report something
                    },
                    function(progress) {
                     // report progress
                  });
                }else if(error.status ==502) {
                  serverError()
                } else {
                  alertService('danger','Opps! ', error.data.error.message);
                }
              });
            }
            getVideoToken();
            
        },
        'success' : function(file, xhr, response){
            // vmnv.thumbs = ['https://xdn.tf.rs/2017/06/06/234.jpg','https://xdn.tf.rs/2017/06/06/Tan2017-6-6_173428125_9.jpg','https://xdn.tf.rs/2017/06/06/Tan2017-6-6_17316245_1.jpg'];
            var data = JSON.parse(response.currentTarget.response);
            vmnv.thumbsLocked = angular.copy(data.thumbs);
            vmnv.thumbs = data.thumbs;
            vmnv.mp4 = data.mp4;
            vmnv.m3u8 = data.uri;
            vmnv.encodingId = data.encodingId;
            vmnv.duration = data.duration;
            vmnv.resolutions = data.resolutions;
            var imageThumbElement = [];
            for(var i=0; i<vmnv.thumbs.length;i++) {
                vmnv.thumbs[i]=vmnv.config.baseVideoHref + vmnv.thumbs[i].replace('.jpg','-254x191.jpg'); 
                vmnv.thumbsLoaded[i]=false;
                vmnv.thumbsLoaded.all=false;
            }
            vmnv.uploadVideoRequired = false;
            vmnv.uploaded = true;
            // vmnv.image = vmnv.thumbs[0];
            // if(vmnv.selectedTranscoding.value == vmnv.config.videoUploadVersion) {
              vmnv.dateDefault = vmnv.m3u8.substring(9,19);  
            // } else {
              // vmnv.dateDefault = vmnv.m3u8.substring(1,11);
            // }
            vmnv.date = vmnv.dateDefault.replace(/\//g,'-');
            vmnv.thumbDir = vmnv.m3u8.substring(0, vmnv.m3u8.lastIndexOf('/'));
            vmnv.loadedInterval = $interval(function(){

                var iLoaded = 0
                var imageThumbElement = angular.element(document.getElementsByClassName('thumb_upload'));
                for(var i = 0; i<imageThumbElement.length;i++) {
                    imageThumbElement[i].src = undefined;
                    imageThumbElement[i].src = vmnv.thumbs[i];
                    jQuery(imageThumbElement[i]).off('load').on('load',function(i) {
                        var index = jQuery(this).attr('index');
                        iLoaded++
                        $scope.$apply(function() {
                            vmnv.thumbsLoaded[index] = true;
                        })
                        if(iLoaded==imageThumbElement.length) {
                           $interval.cancel(vmnv.loadedInterval);
                           $scope.$apply(function() {
                                vmnv.thumbsLoaded.all = true;
                                 vmnv.selectedImage = 0;
                                 vmnv.image = vmnv.thumbsLocked[0];
                                 vmnv.thumbRequired = false;
                           })
                           jQuery('.upload-image').attr('src', vmnv.thumbs[0]);
                        }
                    }); 
                }
            },5000)
        },
        'error' : function(file,message) {
          if(message && message.error && message.error.message) {
            jQuery(file.previewElement).find('.dz-error-message').text(message.error.message);
          }
        },
        'sending':function(file, xhr, formData) {
            formData.append('video_id', vmnv.videoNew.video_id);
            if(vmnv.selectedVideoQuality.value) {
              formData.append('quality', vmnv.selectedVideoQuality.value);
          }
        }
    };
    vmnv.dzOptionsThumb = {
        url : 'https://upload.telegraf.tv/api/'+vmnv.selectedTranscoding.value+'/thumb/update',
        paramName : 'filename',
        maxFilesize : '500000',
        parallelUploads: 10,  
        acceptedFiles : 'image/jpeg, images/jpg',
        addRemoveLinks : true,
        autoProcessQueue : false,
        dictInvalidFileType: 'This file type is not supported.',
        dictFileTooBig:'File size too Big',
        dictDefaultMessage : "Drop image here to upload",
        headers:{
          'x-auth': null  
        },      
    };
    vmnv.dzCallbacksThumb = {
        'processing': function(file) {
          var dz = vmnv.dzMethodsThumb.getDropzone();
          dz.options.url= 'https://upload.telegraf.tv/api/'+vmnv.selectedTranscoding.value+'/thumb/update';
        }, 
        'addedfile' : function(file){
            vmnv.newFileThumb = file;
            var promise = refreshtokenService.getAccessToken();
            promise.then(
              function(answer) {
                    var token = authtokenService.getToken();
                    vmnv.dzOptionsThumb.headers['x-auth'] = token;
                    vmnv.dzMethodsThumb.processQueue();
              },
              function(error) {
                // report something
              },
              function(progress) {
               // report progress
            });
            
        },
        'success' : function(file, xhr, response){
            var data = JSON.parse(response.currentTarget.response);
            vmnv.customThumb = data.image;
            vmnv.customThumbsLocked = angular.copy(data.image);
            vmnv.uploadedThumb = true;
            if(vmnv.thumbsLocked.length == vmnv.thumbs.length) {
                vmnv.thumbs.push(vmnv.config.baseVideoHref + vmnv.customThumb.replace('.jpg','-254x191.jpg')); 
            } else {
                vmnv.thumbs.splice(-1,1);
                vmnv.thumbs.push(vmnv.config.baseVideoHref + vmnv.customThumb.replace('.jpg','-254x191.jpg'));
            }
            vmnv.thumbsLoaded[vmnv.thumbs.length-1] = false;
            vmnv.selectedImage = vmnv.thumbs.length-1;
            vmnv.thumbRequired = false;
            vmnv.image = vmnv.customThumbsLocked;
            jQuery('.upload-image').attr('src', vmnv.thumbs[vmnv.thumbs.length-1])
        },
        'error' : function(response,message) {
        },
        'sending':function(file, xhr, formData) {
            formData.append('video_id', vmnv.videoNew.video_id);
            formData.append('date', vmnv.date);
            formData.append('dir', vmnv.thumbDir);
        }
    };
    // Apply methods for dropzone
    // Visit http://www.dropzonejs.com/#dropzone-methods for more methods
    // vmnv.dzMethods = {
    //     'init': function() {
          
    //     }
    // };
    vmnv.updateSafety = function(safeId, checked) {
      if(checked) {
        for(var i = 0; i<vmnv.addSafety.length;i++) {
          vmnv.checkedItems[vmnv.addSafety[i]._id] = false
        }
        vmnv.checkedItems[safeId]= true;
        vmnv.safe = safeId;  
      } else {
        vmnv.safe = null;
      }
    }
    var addNewTagFunction = function(data) {
      vmnv.newTagRequired = false;
      if(!checkArray.contains.call(vmnv.tags,data.tagId)) {
        vmnv.tags.push(data.tagId);
        vmnv.searchtagfocus = null;
        vmnv.existTag = false;
      } else {
        vmnv.existTag = true;
      }
    }
    $scope.$on('select-tag', function(event,data) {
      addNewTagFunction(data.selectedTagObj)
    });
    vmnv.addNewTag = function() {
      if(vmnv.searchtagfocus && vmnv.searchtagfocus.length>1) {
        var postFunction = function() {
          postDataService.save({
            param1:'video-tags', 
            // param2: 'create'
          },{
            'name': vmnv.searchtagfocus
          }).$promise.then(function(postTag){
          var data = {
            tagId:postTag.tag._id,
            tagname: postTag.tag.name
          } 
            addNewTagFunction(data);
          }, function(error){
            if(!window.navigator.onLine) {
              offlineError()
              alertService('danger','Opps! ', 'Please check your internet connection and try again.');
              return
            }
            if(error.status ==401) {
              var promise = refreshtokenService.getAccessToken();
              promise.then(
                function(answer) {
                  if(answer==200) {   
                    postFunction();
                  }
                },
                function(error) {
                },
                function(progress) {
                 // report progress
              });
            } else if(error.status ==502) {
              serverError()
            } else if(error.status ==400) {
              var data = {
                tagId:error.data.tag._id,
                tagname: error.data.tag.name
              } 
              addNewTagFunction(data);
            }
          });
        }
        postFunction();
      } else {
        vmnv.newTagRequired = true;
      }
    }
    vmnv.removeFromTagsList = function(index) {
      vmnv.tags.splice(index, 1);
    }

    var getVideoCategoriesFunction = function() {
        getDataService.get({param1: 'video-categories', tree:1}).$promise.then(function(dataCategory){
            vmnv.categories = dataCategory.categories;
            vmnv.categoriesTreeInput = reqursiveService.getReqursiveArray(vmnv.categories);
        }, function(error){
          if(!window.navigator.onLine) {
            offlineError()
            $rootScope.hasLoaded = true;
            return
          }
          if(error.status ==401) {
            var promise = refreshtokenService.getAccessToken();
            promise.then(
                function(answer) {
                  if(answer==200) {
                    getVideoCategoriesFunction();
                  }
              },
              function(error) {
                // report something
              },
              function(progress) {
               // report progress
            });
          } else if(error.status ==502) {
            serverError()
          } else {
            alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
          }
          $rootScope.hasLoaded = true;
        });
    }  
    getVideoCategoriesFunction();
     vmnv.updateSelection = function(category_id, checked) {
      var updateSelectionTree = function(categories) {
        if(checked) {
          for (var i=0; i<categories.length; i++){
            if (categories[i]._id !== category_id) {
              vmnv.categorychecked.item[categories[i]._id] = false;
            }
          }
          vmnv.category = category_id;
        } else {
          vmnv.category = null;
        }
      }
      updateSelectionTree(vmnv.categoriesTreeInput);   
    }
    vmnv.saveVideos = function() {
        var validation = true;
        if(vmnv.titleExceed) {
            validation = false;
            alertService('danger','Opps! ', 'Maximum number of characters in title is 100');
        }
        if(!vmnv.uploaded) {
            validation = false;
            vmnv.uploadVideoRequired = true;
        } else {
            vmnv.uploadVideoRequired = false;
        }
        if(!vmnv.upload_title) {
            validation = false;
            vmnv.titleRequired = true;
        } else {
            vmnv.titleRequired = false;
        }
        if(vmnv.tags.length == 0) {
            validation = false;
            vmnv.tagsRequired = true;
        } else {
            vmnv.tagsRequired = false;
        }
        if(!vmnv.category) {
            validation = false;
            vmnv.categoryRequired = true;
        } else {
            vmnv.categoryRequired = false;
        }
        if(!vmnv.image) {
            vmnv.thumbRequired = true;
            validation = false;
        } else {
            vmnv.thumbRequired = false;
        }
        if(!vmnv.safe) {
          vmnv.videoSafeRequired = true;
          validation = false;
        } else {
          vmnv.videoSafeRequired = false;
        }
        var updateFunction = function() {
            $rootScope.hasLoaded = false;
            var url = API_URL + state + '/' + vmnv.videoNew._id;
            var videoData = {
              'video_id':vmnv.videoNew.video_id,
              'title': (vmnv.upload_title)? (vmnv.upload_title).replace(/\r?\n|\r/g, ' '): '',
              'subtitle': (vmnv.upload_subtitle)? (vmnv.upload_subtitle).replace(/\r?\n|\r/g, ' '): '',
              'category':vmnv.category,
              'tags': vmnv.tags,
              'file': {
                  'mp4': vmnv.mp4,
                  'm3u8': vmnv.m3u8
              },
              'image': vmnv.image,
              'custom_image':vmnv.customThumb,
              'thumbs':vmnv.thumbsLocked,
              'signature':vmnv.upload_signature,
              'status': 'draft',
              'meta':{
                'safe':vmnv.safe
              },
              'allowance':vmnv.geoAllow,
              'encodingId': vmnv.encodingId,
              'duration':vmnv.duration,
              'resolutions':vmnv.resolutions
            }
  
            $http.put(url , videoData)
            .success(function (data, stat, headers) {
                $rootScope.hasLoaded = true;
                $state.go('app.allvideos', {id:vmnv.videoNew._id});
                alertService('success','Success ', data.message, 2000);   
            })
            .error(function (data, status, header, config) {
              if(!window.navigator.onLine) {
                offlineError()
                $rootScope.hasLoaded = true;
                alertService('danger','Opps! ', 'Please check your internet connection and try again.');
                return
              }
              if(status ==401) {
                  var promise = refreshtokenService.getAccessToken();
                  promise.then(
                    function(answer) {
                      if(answer==200) {   
                        updateFunction();
                      }
                    },
                    function(error) {
                    },
                    function(progress) {
                      // report progress
              });
              }else if(status ==502) {
                  serverError()  
              }else { 
                  alertService('danger','Opps! ', (data && data.error && data.error.message)? data.error.message:'Failed to load response data.');
              }
              $rootScope.hasLoaded = true;
            }); 
        }    
        if(validation) {
            updateFunction();
        }
    }
    $scope.$on("$destroy", function() {
        $interval.cancel(vmnv.loadedInterval);
    });
  }	
}



//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/videoModule/new-video/js/newVideoController.js
// module id = 645
// module chunks = 0